import { Form, useForm } from "@portal/BaseComponents/Form/AntForm";
import { StyledFormItem } from "@portal/BaseComponents/Form/style";
import { TypographyText } from "@portal/BaseComponents/Typography/AntTypography";
import { FormFooter } from "@portal/BaseComponents/UI/FormArea/FormFooter";
import { CommentForm } from "../CommentFormComponents";
import { StyledCommentBox } from "./style";
interface CommentBoxProps {
  onClose: () => void;
  getUpdatedValues?: (value: string) => void;
  value?: string;
  placeholder?: string;
}
function CommentBox(props: CommentBoxProps) {
  const { onClose, getUpdatedValues, value, placeholder } = props;
  const [form] = useForm<{ comment: string }>();
  function handleSubmit() {
    form.validateFields().then(() => {
      const values = form.getFieldsValue();
      getUpdatedValues?.(values.comment);
    });
  }

  const Label = (
    <TypographyText strong fs="16">
      Comment
    </TypographyText>
  );
  const CommentArea = (
    <StyledFormItem
      label={Label}
      space="sp-1"
      name="comment"
      required={false}
      initialValue={value}
      style={{ width: "100%" }}
      preserve={false}
      rules={[{ required: true, message: "This Field is Required" }]}
    >
      <CommentForm placeholder={placeholder} />
    </StyledFormItem>
  );
  const Comment = (
    <Form form={form} layout="vertical" style={{ width: "100%" }}>
      {CommentArea}
    </Form>
  );
  const Footer = (
    <FormFooter
      cancelButtonProps={{ onClick: onClose }}
      saveButtonProps={{ onClick: handleSubmit, text: "Add" }}
      style={{ background: "var(--gray-1)" }}
    />
  );



  return <StyledCommentBox actions={[Footer]}>{Comment}</StyledCommentBox>;
}

export { CommentBox };
